import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
export const SoundWave = ({ color = '#fff', width = 20, height = 20 }) => (
  <Svg width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M10 1.875c.345 0 .625.28.625.625v15a.625.625 0 1 1-1.25 0v-15c0-.345.28-.625.625-.625ZM13.333 4.375c.345 0 .625.28.625.625v10a.625.625 0 1 1-1.25 0V5c0-.345.28-.625.625-.625ZM3.958 8.333a.625.625 0 0 0-1.25 0v3.334a.625.625 0 0 0 1.25 0V8.333ZM6.666 5.208c.346 0 .625.28.625.625v8.334a.625.625 0 0 1-1.25 0V5.833c0-.345.28-.625.625-.625ZM17.291 8.333a.625.625 0 1 0-1.25 0v3.334a.625.625 0 0 0 1.25 0V8.333Z"
    />
  </Svg>
)
